<div class="flex j-end">
    <div class="box-details">
        <div class="box-details__content line-bottom"><span>Patente</span>
            <h3 id="sidePatente">{{item.patente}}</h3>
        </div>
        <div class="box-details__content line-bottom"><span id="sideMarca">{{item.marca}}</span>
            <h3 id="sideModelo">{{item.modelo}}</h3>
        </div>
        <div class="box-details__content line-bottom"><span>Año</span>
            <h3 id="sideAnio">{{item.anno}}</h3>
        </div>
        <div class="box-details__content"><span>Deducible</span>
            <h3 id="sideDeducible">{{item.deducible | currency:"CLP":"":0:'es_CL' }} UF</h3>
        </div>
        <div class="box-details__content"><span>R.C.</span>
            <h3 id="sideRc">{{ item.rc | currency:"CLP":"":0:'es_CL'}} UF</h3>
        </div>
        <div class="box-details__content"><span>Auto de reemplazo</span>
            <h3 id="sideReemplazo">{{item.autoReemplazo}}</h3>
        </div>
        <div class="box-details__content"><span>Taller</span>
            <h3 id="sideTaller">{{item.taller}}</h3>
        </div>
    </div>
</div>